import { render, staticRenderFns } from "./digitalHuman_2d_boutique.vue?vue&type=template&id=4c07a05e&scoped=true"
import script from "./digitalHuman_2d_boutique.vue?vue&type=script&lang=js"
export * from "./digitalHuman_2d_boutique.vue?vue&type=script&lang=js"
import style0 from "./digitalHuman_2d_boutique.vue?vue&type=style&index=0&id=4c07a05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07a05e",
  null
  
)

export default component.exports